// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { AFS_PARAMETERS } from 'redux/modules/interferenceAnalysis/constants'
import { postRunProjectAnalysis } from 'helpers/api/project'
import formatErrorData from 'helpers/reduxFormFunctions/formatErrorData'
import loadingToggler from 'redux/modules/loading/loadingToggler'
import submitInterferenceParameters from 'redux/modules/interferenceAnalysis/thunks/submitInterferenceParameters'
import initializeParameters from 'redux/modules/interferenceAnalysis/thunks/initializeParameters'

import {
  isPristine,
  stopSubmit,
} from 'redux-form'

// this is used on the analysis parameters page to trigger all
// configured analysis types to run for all specified bands.
// (See AFS parameters form to see what I'm talking about.)

const triggerProjectAnalysisToRun = () => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const {
        form,
        projectSummary,
      } = getState()

      const formValues = form[AFS_PARAMETERS].values
      const pristineParameters = isPristine(AFS_PARAMETERS)({ form })
      const projectId = projectSummary.get('projectId')

      // if AFS Parameters have been changed, update them in DB before moving on.
      try {
        // if the AFS parameters form is not pristine, then we need to save
        // those changes first before triggering the analysis to run
        // here
        if (pristineParameters === false) {
          await dispatch(submitInterferenceParameters(formValues))
        }

        await postRunProjectAnalysis(projectId)

        return dispatch(initializeParameters())
      } catch (err) {
        console.warn(err)
        dispatch(stopSubmit(
          AFS_PARAMETERS,
          formatErrorData(err),
        ))
      }
    })
  )
)

export default triggerProjectAnalysisToRun
